const config = {
  ENVIRONMENT_NAME: 'testing',
  forwoodId: {
    URL: 'https://id.testing.eurecovery.forwoodsafety.com',
    USER_TOKEN_URL: 'https://id.testing.eurecovery.forwoodsafety.com/api'
  },
  apiGateway: {
    REGION: 'eu-west-1',
    URL: 'https://lq4hk9ydnc.execute-api.eu-west-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.2',
    HOSTNAME: 'https://admin.testing.eurecovery.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.testing.eurecovery.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.testing.eurecovery.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.eurecovery.forwoodsafety.com',
    WEBSOCKET: 'wss://mx3s7li7i2.execute-api.eu-west-1.amazonaws.com/testing'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
